<div class="cardStyle" [style.padding-bottom]="main ? '10px' : '0'">
  <div class="cardStyle-inner">
    <ng-content> </ng-content>
  </div>
</div>
